import React from "react";
import "./hospitality.css";
import OverlayCard from "../../components/OverlayCard";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Carousel } from "../../components/VerticalCarousel";
import vivre from "../../assets/solutions/Vivre.png";
import sia from "../../assets/solutions/sia.png";
import b1 from "../../assets/hospitality/omini.png"
import b2 from "../../assets/hospitality/exp.png"
import b3 from "../../assets/hospitality/revenue.png"
import hos from "../../assets/hospitality/image 46.png"
import CardGrid from "../../components/productCardsGrid/productInfoCards";


export default function Hospitality() {
const cards=[
  {
    "title": "Easy to Configure Hospitality Solutions",
    "description": "Set up your hospitality services quickly with our easy-to-configure platform, designed for fast customization and minimal setup time."
  },
  {
    "title": "Increase Your Revenue",
    "description": "Boost profitability by enhancing guest experiences and expanding service offerings with our hospitality solutions."
  },
  {
    "title": "Extend Your Services",
    "description": "Expand your offerings with additional features and amenities to increase service value and guest satisfaction."
  },
  {
    "title": "Multi-Tenanted Management",
    "description": "Manage multiple properties effortlessly from one account with our multi-tenanted hospitality solutions."
  },
  {
    "title": "Bundle OTT Providers",
    "description": "Combine multiple OTT services into one seamless package, delivering a rich content experience for guests."
  },
  {
    "title": "Interactive Guest Experiences",
    "description": "Engage guests with interactive features, offering personalized and immersive hospitality experiences."
  },
  {
    "title": "OTT Free Service – Live & On Demand",
    "description": "Deliver live and on-demand OTT content for free, offering a variety of entertainment options to guests."
  },
  {
    "title": "Locally Ingested Content with DRM",
    "description": "Stream locally ingested content securely with integrated Digital Rights Management (DRM) for compliance and protection."
  },
  {
    "title": "Integrated Hospitality Tools",
    "description": "Manage hotel devices, display personalized welcome banners, enable room service orders, view guest bills, and collect feedback seamlessly."
  }
]




  const whitepapers = [
    {
      id: 1,
      src: hos,
      alt: "image1 for carousel",
    },
    // {
    //   id: 2,
    //   src: vivre,
    //   alt: "image 2 for carousel",
    // },
  ];
 
  const blogs = [
    { title: 'Omni Channels', description: 'We have enabled many large operators with Omni channel experience for hotel guests.', name: '', image: b1 },
    { title: 'Experience', description: 'Bring unparallel user experience through unification of OTT, Gaming, E-Commerce and other service offerings.', name: '', image: b2 },
    { title: 'Revenue', description: 'Increase your offerings / revenues from your Guests by upto 2x.', name: '', image: b3 },
  
  ];
  return (
    <div>
    <div className="bcontainer" style={{background:"black"}} >
      <div className="vivre-container"  >
        <div className="vivre-logo">
          <img src={require("../../assets/hospitality/logo1.png")} alt="" />
          <h3>Hospitality</h3>
        </div>
        <div className="vivre-des">
          <p>
            We provide Top Tier and Smart Hospitality solutions that personalize every guest's experience for the Hospitality Industry by leveraging our OTT experience.
            
          </p>
        </div>
        <OverlayCard blogs={blogs} />
      </div>
      <div className="">
        {/* <img src={require("../../assets/vivre/SARA Insights.png")} /> */}
        <div className="hospitality1-carousel">
          <Carousel data={whitepapers} />
          <div className="hospitality-des">
            <div className="hospitality-title">
              <h3>Movies and LIVE </h3>
              <h3>TV - Kaltura</h3>
              <p>• Empower your guests to watch Video on Demand through rich and interactive OTT Experience on Guest’s TV.</p>
              <p>• Increase your revenue and value add by offering LIVE TV and VOD as On-Demand or Pay per view.</p>
              <p>• Monetize through AVOD offerings.</p>
              <p>• Sell Local Content</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="w-m-s-p">
          <div className="sara-title2">
            <h3>What makes our Hospitality Services Special</h3>
          </div>
         <div>
          <CardGrid cards={cards}/>
         </div>
        </div>
      </div>
      
    </div>
    <NewFooter />
    </div>
  );
}

